
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faArrowDown, faArrowUp, faEdit, faEllipsisH, faExternalLinkAlt, faEye, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Nav, Card, Image, Button, Table, Dropdown, ProgressBar, Pagination, ButtonGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import { pageVisits, pageTraffic, pageRanking } from "../data/tables";
import transactions from "../data/transactions";
import tripsData from "../data/tripsData";
import RouteMasterdata from "../data/routesMasterData";
import commands from "../data/commands";
import { useState, useEffect } from "react";
import { getDriverDetails, setDriverDetails,  } from "../api/services/userService";
import TmsPopup from "../components/Popup"; // Path to your code above
import DriverDetailsForm from "../pages/forms/DriverDetailsForm";
import VehicleDetailsForm from "../pages/forms/VehicleDetailsForm";
import { getVehicleDetails,setVehicleStatus } from "../api/services/vehicleService";

const ValueChange = ({ value, suffix }) => {
  const valueIcon = value < 0 ? faAngleDown : faAngleUp;
  const valueTxtColor = value < 0 ? "text-danger" : "text-success";

  return (
    value ? <span className={valueTxtColor}>
      <FontAwesomeIcon icon={valueIcon} />
      <span className="fw-bold ms-1">
        {Math.abs(value)}{suffix}
      </span>
    </span> : "--"
  );
};

export const PageVisitsTable = () => {
  const TableRow = (props) => {
    const { pageName, views, returnValue, bounceRate } = props;
    const bounceIcon = bounceRate < 0 ? faArrowDown : faArrowUp;
    const bounceTxtColor = bounceRate < 0 ? "text-danger" : "text-success";

    return (
      <tr>
        <th scope="row">{pageName}</th>
        <td>{views}</td>
        <td>${returnValue}</td>
        <td>
          <FontAwesomeIcon icon={bounceIcon} className={`${bounceTxtColor} me-3`} />
          {Math.abs(bounceRate)}%
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5>Page visits</h5>
          </Col>
          <Col className="text-end">
            <Button variant="secondary" size="sm">See all</Button>
          </Col>
        </Row>
      </Card.Header>
      <Table responsive className="align-items-center table-flush">
        <thead className="thead-light">
          <tr>
            <th scope="col">Page name</th>
            <th scope="col">Page Views</th>
            <th scope="col">Page Value</th>
            <th scope="col">Bounce rate</th>
          </tr>
        </thead>
        <tbody>
          {pageVisits.map(pv => <TableRow key={`page-visit-${pv.id}`} {...pv} />)}
        </tbody>
      </Table>
    </Card>
  );
};

export const PageTrafficTable = () => {
  const TableRow = (props) => {
    const { id, source, sourceIcon, sourceIconColor, sourceType, category, rank, trafficShare, change } = props;

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {source}
        </td>
        <td>{sourceType}</td>
        <td>{category ? category : "--"}</td>
        <td>{rank ? rank : "--"}</td>
        <td>
          <Row className="d-flex align-items-center">
            <Col xs={12} xl={2} className="px-0">
              <small className="fw-bold">{trafficShare}%</small>
            </Col>
            <Col xs={12} xl={10} className="px-0 px-xl-1">
              <ProgressBar variant="primary" className="progress-lg mb-0" now={trafficShare} min={0} max={100} />
            </Col>
          </Row>
        </td>
        <td>
          <ValueChange value={change} suffix="%" />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">#</th>
              <th className="border-0">Traffic Source</th>
              <th className="border-0">Source Type</th>
              <th className="border-0">Category</th>
              <th className="border-0">Global Rank</th>
              <th className="border-0">Traffic Share</th>
              <th className="border-0">Change</th>
            </tr>
          </thead>
          <tbody>
            {pageTraffic.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const RankingTable = () => {
  const TableRow = (props) => {
    const { country, countryImage, overallRank, overallRankChange, travelRank, travelRankChange, widgetsRank, widgetsRankChange } = props;

    return (
      <tr>
        <td className="border-0">
          <Card.Link href="#" className="d-flex align-items-center">
            <Image src={countryImage} className="image-small rounded-circle me-2" />
            <div><span className="h6">{country}</span></div>
          </Card.Link>
        </td>
        <td className="fw-bold border-0">
          {overallRank ? overallRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={overallRankChange} />
        </td>
        <td className="fw-bold border-0">
          {travelRank ? travelRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={travelRankChange} />
        </td>
        <td className="fw-bold border-0">
          {widgetsRank ? widgetsRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={widgetsRankChange} />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">Country</th>
              <th className="border-0">All</th>
              <th className="border-0">All Change</th>
              <th className="border-0">Travel & Local</th>
              <th className="border-0">Travel & Local Change</th>
              <th className="border-0">Widgets</th>
              <th className="border-0">Widgets Change</th>
            </tr>
          </thead>
          <tbody>
            {pageRanking.map(r => <TableRow key={`ranking-${r.id}`} {...r} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const TransactionsTable = () => {
  const totalTransactions = transactions.length;

  const TableRow = (props) => {
    const { tripId, destination, goodPrice, issueDate, deliveryDate, status } = props;
    const statusVariant = status === "Paid" ? "success"
      : status === "Due" ? "warning"
        : status === "Canceled" ? "danger" : "primary";

    return (
      <tr>
        <td>
          <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
            {tripId}
          </Card.Link>
        </td>
        <td>
          <span className="fw-normal">
            {destination}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {issueDate}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {deliveryDate}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            ${parseFloat(goodPrice).toFixed(2)}
          </span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {status}
          </span>
        </td>
        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
              </Dropdown.Item>
              <Dropdown.Item className="text-danger">
                <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">Trip Id</th>
              <th className="border-bottom">Destination</th>
              <th className="border-bottom">Dispatch Date</th>
              <th className="border-bottom">Ex Del Date</th>
              <th className="border-bottom">Good Price</th>
              <th className="border-bottom">Status</th>
              <th className="border-bottom">Action</th>
            </tr>
          </thead>
          <tbody>
            {tripsData.map(t => <TableRow key={`transaction-${t.tripId}`} {...t} />)}
          </tbody>
        </Table>
        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <Nav>
            <Pagination className="mb-2 mb-lg-0">
              <Pagination.Prev>
                Previous
              </Pagination.Prev>
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Item>3</Pagination.Item>
              <Pagination.Item>4</Pagination.Item>
              <Pagination.Item>5</Pagination.Item>
              <Pagination.Next>
                Next
              </Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-bold">
            Showing <b>{totalTransactions}</b> out of <b>25</b> entries
          </small>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};


export const TripsTable = () => {
  const totalTransactions = transactions.length;

  const TableRow = (props) => {
    const { tripId, destination, goodPrice, issueDate, deliveryDate, status } = props;
    const statusVariant = status === "Paid" ? "success"
      : status === "Due" ? "warning"
        : status === "Canceled" ? "danger" : "primary";

    return (
      <tr>
        <td>
          <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
            {tripId}
          </Card.Link>
        </td>
        <td>
          <span className="fw-normal">
            {destination}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {issueDate}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {deliveryDate}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            ${parseFloat(goodPrice).toFixed(2)}
          </span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {status}
          </span>
        </td>
        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
              </Dropdown.Item>
              <Dropdown.Item className="text-danger">
                <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">Trip Id</th>
              <th className="border-bottom">Destination</th>
              <th className="border-bottom">Dispatch Date</th>
              <th className="border-bottom">Ex Del Date</th>
              <th className="border-bottom">Good Price</th>
              <th className="border-bottom">Status</th>
              <th className="border-bottom">Action</th>
            </tr>
          </thead>
          <tbody>
            {tripsData.map(t => <TableRow key={`transaction-${t.tripId}`} {...t} />)}
          </tbody>
        </Table>
        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <Nav>
            <Pagination className="mb-2 mb-lg-0">
              <Pagination.Prev>
                Previous
              </Pagination.Prev>
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Item>3</Pagination.Item>
              <Pagination.Item>4</Pagination.Item>
              <Pagination.Item>5</Pagination.Item>
              <Pagination.Next>
                Next
              </Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-bold">
            Showing <b>{totalTransactions}</b> out of <b>25</b> entries
          </small>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};


export const CommandsTable = () => {
  const TableRow = (props) => {
    const { name, usage = [], description, link } = props;

    return (
      <tr>
        <td className="border-0" style={{ width: '5%' }}>
          <code>{name}</code>
        </td>
        <td className="fw-bold border-0" style={{ width: '5%' }}>
          <ul className="ps-0">
            {usage.map(u => (
              <ol key={u} className="ps-0">
                <code>{u}</code>
              </ol>
            ))}
          </ul>
        </td>
        <td className="border-0" style={{ width: '50%' }}>
          <pre className="m-0 p-0">{description}</pre>
        </td>
        <td className="border-0" style={{ width: '40%' }}>
          <pre><Card.Link href={link} target="_blank">Read More <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" /></Card.Link></pre>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body className="p-0">
        <Table responsive className="table-centered rounded" style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          <thead className="thead-light">
            <tr>
              <th className="border-0" style={{ width: '5%' }}>Name</th>
              <th className="border-0" style={{ width: '5%' }}>Usage</th>
              <th className="border-0" style={{ width: '50%' }}>Description</th>
              <th className="border-0" style={{ width: '40%' }}>Extra</th>
            </tr>
          </thead>
          <tbody>
            {commands.map(c => <TableRow key={`command-${c.id}`} {...c} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const DriversTable = ({ driversResponse, onPageChange }) => {
  const drivers = driversResponse?.drivers || [];
  const totalPages = driversResponse?.total_pages || 1;
  const currentPage = driversResponse?.current_page ?? 1;
  const totalDrivers = driversResponse?.total_items || 0;
  const [showDriverAddWindow, setShowDriverAddWindow] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [is_active, setIsActive] = useState(false);
  // 🔥 Actions
  const handleEdit = (driver) => console.log("Edit:", driver);
  const handleDelete = (driver) => console.log("Delete:", driver);

  const handleView = async (dl_num) => {
    // e.preventDefault();
    console.log("View:", dl_num);
    try {

      const driverDetails = await getDriverDetails(dl_num);
      console.log("Driver Details:", driverDetails);
      setSelectedDriver(driverDetails);
      setIsActive(driverDetails.is_active);
      console.log("Driver Active Status:", driverDetails.is_active);
      setShowDriverAddWindow(true);
    } catch (error) {
      console.error("Error fetching driver details:", error);
    }
  };

  const handleInactive = async (dl_num, currentStatus) => {
    try {
      const newStatus = !currentStatus;

      const response = await setDriverDetails(dl_num, newStatus);
      console.log("Response from API:", response);
      console.log("Status updated:", newStatus);
      window.location.reload();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  // 🔥 Row Component
  const TableRow = ({ first_name, last_name, phone, dl_num, is_active }) => {
    const statusVariant = is_active ? "success" : "danger";

    return (
      <tr>
        <td className="fw-bold">
          {first_name} {last_name}
        </td>
        <td>{phone}</td>
        <td>{dl_num}</td>
        <td>
          <span className={`fw-bold text-${statusVariant}`}>
            {is_active ? "Active" : "Inactive"}
          </span>
        </td>
        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle
              as={Button}
              split
              variant="link"
              className="text-dark m-0 p-0"
            >
              <FontAwesomeIcon icon={faEllipsisH} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleView(dl_num)}>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View
              </Dropdown.Item>

              {/* <Dropdown.Item onClick={() => handleEdit({ first_name, last_name })}>
                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
              </Dropdown.Item> */}

              <Dropdown.Item
                className="text-danger"
                onClick={() => handleInactive(dl_num, is_active)}
              >
                {is_active ? (
                  <>
                    <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Inactive
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faEdit} className="me-2" /> Active
                  </>
                )}
                {/* </Dropdown.Item> */}
                {/* <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Inactive */}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">

        {/* Table */}
        <Table hover className="align-items-center">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>License No</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {drivers.length > 0 ? (
              drivers.map((driver, index) => (
                <TableRow key={index} {...driver} />
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  No drivers found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* 🔥 Pagination */}
        <Card.Footer className="px-3 border-0 d-flex justify-content-between align-items-center">

          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            />

            {[...Array(totalPages)].map((_, index) => (
              <Pagination.Item
                key={index}
                active={currentPage === index + 1}
                onClick={() => onPageChange?.(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}

            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            />

          </Pagination>

          <small className="fw-bold">
            Total Drivers: <b>{totalDrivers}</b>
          </small>

          <TmsPopup show={showDriverAddWindow}
            handleClose={() => setShowDriverAddWindow(false)}
            title="Driver Details"
            onSave={() => {
              console.log("Save clicked");
              setShowDriverAddWindow(false);
            }}>
            <DriverDetailsForm data={selectedDriver} />
          </TmsPopup>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};


export const VehiclesTable = ({ VehiclesResponse, onPageChange, filterType, setFilterType }) => {
  const vehicles = VehiclesResponse?.vehicles || [];
  const totalPages = VehiclesResponse?.total_pages || 1;
  const currentPage = VehiclesResponse?.current_page ?? 1;
  const totalVehicles = VehiclesResponse?.total_items || 0;
  // const [filterType, setFilterType] = useState("ALL");

  const [showVehicleWindow, setShowVehicleWindow] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  // 🔥 View Vehicle
  const handleView = async (id) => {
    try {
      const vehicleDetails = await getVehicleDetails(id);
      setSelectedVehicle(vehicleDetails);
      setShowVehicleWindow(true);
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    }
  };



  const filteredVehicles = vehicles.filter((v) => {
    if (filterType === "THIRD_PARTY") return v.owner_type === 2;
    if (filterType === "BLOCKED") return v.is_active === false;
    return true;
  });

  // 🔥 Activate / Deactivate
  const handleToggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await setVehicleStatus(id, newStatus);

      // ❌ remove reload (bad)
      window.location.reload();

      // ✅ better: trigger parent refresh
      onPageChange(currentPage);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // 🔥 Row Component
  const TableRow = ({
    id,
    vehicle_number,
    vehicle_type_name,
    maker_name,
    model_name,
    is_active
  }) => {
    const statusVariant = is_active ? "success" : "danger";

    return (
      <tr>
        <td className="fw-bold">{vehicle_number}</td>
        <td>{vehicle_type_name}</td>
        <td>{maker_name}</td>
        <td>{model_name}</td>

        <td>
          <span className={`fw-bold text-${statusVariant}`}>
            {is_active ? "Active" : "Inactive"}
          </span>
        </td>

        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle
              as={Button}
              split
              variant="link"
              className="text-dark m-0 p-0"
            >
              <FontAwesomeIcon icon={faEllipsisH} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleView(id)}>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View
              </Dropdown.Item>

              <Dropdown.Item
                className="text-danger"
                onClick={() => handleToggleStatus(id, is_active)}
              >
                {is_active ? (
                  <>
                    <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Inactive
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faEdit} className="me-2" /> Active
                  </>
                )}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">

        {/* Table */}
        <Table hover className="align-items-center">
          <thead>
            <tr>
              <th>Vehicle Number</th>
              <th>Vehicle Type</th>
              <th>Vehicle Make</th>
              <th>Vehicle Model</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredVehicles.length > 0 ? (
              filteredVehicles.map((vehicle, index) => (
                <TableRow key={index} {...vehicle} />
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  No vehicles found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination */}
        <Card.Footer className="px-3 border-0 d-flex justify-content-between align-items-center">

          <Pagination className="mb-0">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            />

            {[...Array(totalPages)].map((_, index) => (
              <Pagination.Item
                key={index}
                active={currentPage === index + 1}
                onClick={() => onPageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}

            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            />
          </Pagination>

          <small className="fw-bold">
            Total Vehicles: <b>{totalVehicles}</b>
          </small>

          <TmsPopup show={showVehicleWindow}
            handleClose={() => setShowVehicleWindow(false)}
            title="Vehicle Details"
            onSave={() => {
              console.log("Save clicked");
              setShowVehicleWindow(false);
            }}>
            <VehicleDetailsForm data={selectedVehicle} />
          </TmsPopup>

        </Card.Footer>
      </Card.Body>
    </Card>
  );
};